/**
 * Document title per route (WCAG 2.4.2 Page Titled). The app lives in an
 * iframe inside the Innu Shell, where the tab title is the Shell's, but the
 * title still names the page for screen readers, history and the standalone
 * Pages URL. Format: "<page> · Recruiting".
 */
import { useEffect } from 'react';

export const APP_TITLE = 'Recruiting';

export function pageTitle(title: string): string {
  const t = title.trim();
  return t ? `${t} · ${APP_TITLE}` : APP_TITLE;
}

/**
 * Sets `document.title` while mounted and restores the previous title on
 * unmount. `null` / `undefined` leaves the title alone — the lead drawer
 * reuses `LeadDetail` under the board and must not retitle the page.
 */
export function usePageTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (title === null || title === undefined) return;
    const previous = document.title;
    document.title = pageTitle(title);
    return () => {
      document.title = previous;
    };
  }, [title]);
}
